import React from "react";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { OSH_IMAGES } from "../../lib/worldOsharImages";

const cards = [
  {
    n: 1,
    image: OSH_IMAGES.featureLiveEvents,
    title: "Live Events",
    body:
      "Arena-scale concerts, limited-time raids, and seasonal spectacles—timed drops and crowd energy you can feel in-headset.",
    cta: "View events",
    to: "/world/oshar/real-estate",
  },
  {
    n: 2,
    image: OSH_IMAGES.featureColiseum,
    title: "Gladiator Coliseum",
    body:
      "Bracketed tournaments and gladiator circuits—wager-ready duels where cosmetics, tokens, and bragging rights are on the line.",
    cta: "Enter arena",
    to: "/world/oshar/real-estate",
  },
  {
    n: 3,
    image: OSH_IMAGES.featureCasino,
    title: "Casino & Games",
    body:
      "High-gloss floors, arcade lanes, and table games built for squads—earn perks without leaving the city loop.",
    cta: "Play now",
    to: "/world/oshar/real-estate",
  },
  {
    n: 4,
    image: OSH_IMAGES.featureShopping,
    title: "Shopping Districts",
    body:
      "Skins, weapons, farming kits, and rare assets from verified vendors—your loadout window, now a walkable street.",
    cta: "Browse shops",
    to: "/world/oshar/real-estate",
  },
  {
    n: 5,
    image: OSH_IMAGES.featureVrRealEstate,
    title: "VR Real Estate",
    body:
      "Sky lounges, guild towers, and storefront parcels—lease, decorate, and monetize presence in a city that never sleeps.",
    cta: "See parcels",
    to: "/#sales",
    hash: true,
  },
  {
    n: 6,
    image: OSH_IMAGES.featureConnected,
    title: "Connected to Treydora",
    body:
      "Inventory, tokens, and achievements stay in conversation with the RPG—what you earn in Oshar echoes across the saga.",
    cta: "Learn more",
    to: "/#sales",
    hash: true,
  },
];

const OsharFeatureGrid = () => {
  return (
    <section className="oshar-features" id="oshar-features" aria-labelledby="oshar-features-heading">
      <div className="oshar-inner">
        <header className="oshar-features__head">
          <div className="oshar-rule" />
          <div>
            <p className="oshar-section-eyebrow">City Systems</p>
            <h2 id="oshar-features-heading" className="oshar-section-title">
              FORGE YOUR PATH IN OSHAR
            </h2>
          </div>
          <div className="oshar-rule" />
        </header>

        <div className="oshar-features__grid">
          {cards.map((c) => (
            <article key={c.title} className="oshar-card">
              <span className="oshar-card__num" aria-hidden>
                {c.n}
              </span>
              <div className="oshar-card__media">
                <img src={c.image} alt="" loading="lazy" />
                <div className="oshar-card__media-veil" />
              </div>
              <div className="oshar-card__body">
                <h3>{c.title}</h3>
                <p>{c.body}</p>
                {c.hash ? (
                  <HashLink smooth to={c.to} className="oshar-card__cta">
                    {c.cta} <i className="fas fa-chevron-right" aria-hidden />
                  </HashLink>
                ) : (
                  <Link to={c.to} className="oshar-card__cta">
                    {c.cta} <i className="fas fa-chevron-right" aria-hidden />
                  </Link>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OsharFeatureGrid;
